const TOOL_LABELS: Record<string, string> = {
  list_connections: "List connections",
  update_investigation_coverage: "Update coverage",
  search_skills: "Search skills",
  load_skill: "Load skill",
  skill_read: "Read skill",
  search_tools: "Search tools",
  get_tool_schema: "Get tool schema",
  start_investigation_etl: "Start ETL",
  get_etl_status: "ETL status",
  list_investigation_schema: "List schema",
  analytics_query: "Analytics query",
  execute_typescript: "Run TypeScript",
  inspect_dataset: "Inspect dataset",
  list_datasets: "List datasets",
  resolve_metric_bindings: "Resolve metrics",
  verify_answer: "Verify answer",
  submit_claims: "Submit claims",
  check_claims: "Check claims",
  ask_user: "Ask user",
  get_connect_link: "Connect link",
};

/** Human-readable tool label for status chips and tool stacks. */
export function humanizeToolName(tool: string): string {
  const key = tool.trim();
  if (TOOL_LABELS[key]) return TOOL_LABELS[key]!;
  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
